<template>
  <el-select v-model="selectValue" v-bind="$attrs" @change="onChange" @clear="onClear" :filter-method="filterMethod">
    <template v-if="groupCacheName">
      <el-option-group v-for="group in groupOptionList" :key="group.label" :label="group.label">
        <el-option v-for="item in group.child" :key="item[selkey]" :label="item[sellabel]" :value="item[selkey]"> </el-option>
      </el-option-group>
    </template>
    <template v-else>
      <el-option v-for="item in optionsList" :key="item[selkey]" :label="item[sellabel]" :value="item[selkey]"> </el-option>
    </template>
  </el-select>
</template>

<script>
import { getRecentlyUsed } from '@/common/js/utils'
/**
 * @description: 节流版select，只截取固定长度的列表渲染，减少打开下拉项时卡顿，适用于大数据量下拉显示
 */

let filterTimer = null
export default {
  model: {
    prop: 'value',
    event: 'update'
  },
  props: {
    value: {
      type: [String, Number, Array]
    },
    list: {
      type: Array,
      default: () => []
    },
    max: {
      type: Number,
      default: 80
    },
    // 自定义key
    selkey: {
      type: [String, Number],
      default: 'id'
    },
    // 自定义label
    sellabel: {
      type: [String, Number],
      default: 'name'
    },
    groupCacheName: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      options: this.list,
      selectValue: this.value,
      loading: false
    }
  },
  computed: {
    groupOptionList() {
      return [...getRecentlyUsed(this.groupCacheName, this.options), { label: '', child: this.optionsList }]
    },
    optionsList() {
      // 由于list被截断，当id不在当前截取的list中时会回显不正确
      let valueItem = []
      const maxItemList = this.options.slice(0, this.max)
      if (this.value) {
        const isMultiple = typeof this.$attrs.multiple !== 'undefined'
        const idList = maxItemList.map((i) => i[this.selkey])

        if (isMultiple) {
          // 找到全部的已选项
          const selectedItems = this.options.filter((opt) => this.value.includes(opt[this.selkey]))
          // 找到已选项且没在可视下拉内的
          const appendToVisibleItems = selectedItems.filter((item) => !idList.includes(item[this.selkey]))

          valueItem = valueItem.concat(appendToVisibleItems)
        } else {
          if (!idList.includes(this.value)) {
            const item = this.options.find((opt) => opt[this.selkey] === this.value)
            if (item) {
              valueItem = valueItem.concat(item)
            }
          }
        }
      }
      return maxItemList.concat(valueItem)
    }
  },
  watch: {
    list() {
      this.options = this.list
    },
    value(val) {
      this.selectValue = val
    }
  },
  methods: {
    onChange(e) {
      this.selectValue = e
      this.$emit('update', e)
      this.$emit('change', e)
    },
    onClear() {
      this.filterMethod('')
      this.$emit('clear')
    },
    /**
     * @description: 根据keyword自定义过滤
     * @param {*} query
     */
    filterMethod(query) {
      clearTimeout(filterTimer)
      if (query !== '') {
        const reg = new RegExp(query.toLowerCase())
        filterTimer = setTimeout(() => {
          this.options = this.list.filter((item) => reg.test(item[this.sellabel].toLowerCase()))
        }, 100)
      } else {
        this.options = this.list
      }
    }
  }
}
</script>
